import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography
} from "@mui/material";

interface DialogContinuarProximaOrdemProps {
    open: boolean;
    fornecedorAtual: string;
    proximoFornecedor?: string;
    onContinuar: () => void;
    onFinalizar: () => void;
    onSalvarRascunho: () => void;
}

export default function DialogContinuarProximaOrdem({
    open,
    fornecedorAtual,
    proximoFornecedor,
    onContinuar,
    onFinalizar,
    onSalvarRascunho
}: DialogContinuarProximaOrdemProps) {
    return (
        <Dialog open={open} maxWidth="sm" fullWidth>
            <DialogTitle>
                Ordem de Compra Configurada
            </DialogTitle>
            <DialogContent>
                <Typography>
                    A ordem de compra para o fornecedor <strong>{fornecedorAtual}</strong> foi configurada com sucesso.
                </Typography>
                {proximoFornecedor && (
                    <Typography mt={2}>
                        Deseja continuar para configurar a ordem do fornecedor <strong>{proximoFornecedor}</strong>?
                    </Typography>
                )}
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button
                    variant="outlined"
                    onClick={onSalvarRascunho}
                >
                    Salvar Rascunho
                </Button>
                {proximoFornecedor ? (
                    <>
                        <Button
                            variant="text"
                            onClick={onFinalizar}
                        >
                            Não
                        </Button>
                        <Button
                            variant="contained"
                            onClick={onContinuar}
                            color="primary"
                        >
                            Sim
                        </Button>
                    </>
                ) : (
                    <Button
                        variant="contained"
                        onClick={onFinalizar}
                        color="primary"
                    >
                        Finalizar
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
}
